import Loadable from 'react/components/loadable';

const CopyItemToOtherGymModal = Loadable({
  loader: () => import('react/components/copy_item_to_other_gym_modal'),
  type: 'modal',
});

angular.module('gym').value('CopyItemToOtherGymModal', CopyItemToOtherGymModal);
